require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-campaign-sexual-orientation-gender-identity.json") })
        }
      }, "path---en-us-campaign-sexual-orientation-gender-identity");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-campaign-sexual-orientation-gender-identity!./.cache/json/en-us-campaign-sexual-orientation-gender-identity.json
// module id = 472
// module chunks = 231608221292675